import React from "react";
import { Link } from "react-router-dom";
import "./CategoryJs.css";
const SubCateHeader = (props) => {
  return (
    <>
      <div className="sub-cat-btn ">
        <h2 className="my-3 text-dark fw-bold activitiesBg p-2 btn w-100 ">
          {props.name}
        </h2>
        <Link to={props.link}>
          <i className="fas fa-backward text-warning fw-bold icon-sub"></i>
        </Link>
      </div>
    </>
  );
};

export default SubCateHeader;
